import enGB from './en-GB';

export default {
  'en-GB': enGB,
};
